import { styled, Typography } from '@mui/material';
import appIcon from 'assets/app-icon.png';
import exosLogo from 'assets/logo.png';
import Container from 'components/Container';
import React from 'react';
import { QRCode } from 'react-qrcode-logo';
import { useParams } from 'react-router';

const Logo = styled('img')(({ theme }) => ({
  width: '90px',
  marginTop: theme.baseUnit * 6,
  marginBottom: theme.baseUnit * 8,
}));

const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: theme.colors.gray['1'],
  marginLeft: theme.baseUnit * 12,
  marginRight: theme.baseUnit * 12,
  marginTop: theme.baseUnit * 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.textVariant.title.xl,
  marginBottom: theme.baseUnit * 8,
  fontSize: 56,
  lineHeight: '64px',
  maxWidth: 486,
  textAlign: 'center',
}));

const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.textVariant.title.l,
  color: theme.colors.alias.textSecondary,
  marginTop: theme.baseUnit * 8,
  maxWidth: 514,
  textAlign: 'center',
}));

const LocationQR: React.FC = () => {
  const params = useParams();
  const { locationId } = params;

  return (
    <main>
      <div style={{ flex: 1, display: 'flex' }}>
        <StyledContainer>
          <Logo src={exosLogo} />
          <Title variant="h1">Scan to check-in to your class</Title>
          <QRCode
            value={`https://fit.teamexos.com/location/${locationId}`}
            size={256}
            logoImage={appIcon}
            logoHeight={64}
            logoWidth={64}
            quietZone={0}
          />
          <Text>
            Scan the QR code to see the schedule, book a class, or sign into a
            class.
          </Text>
        </StyledContainer>
      </div>
    </main>
  );
};
export default LocationQR;
